import styled from 'styled-components';

export const FilesContainer = styled.div`
  width: 100%;
  padding: 8px 15px 16px;
  position: relative;

  .slick-prev {
    top: -43px !important;
    right: 95px;
    left: auto;
    color: red;
  }

  .slick-next {
    top: -43px !important;
    right: 25px !important;
    color: red;
  }

  .box {
    display: flex;
    align-items: center;
    gap: 12px;
  }
`;

export const TabsContainer = styled.div`
  width: 100%;
  padding: 0 15px 17px 15px;
  position: relative;
  display: flex;
  justify-content: space-between;
  align-items: center;

  .tabs {
    width: calc(100% - 200px);
    border-radius: 7px;
    background: #f6f5f8;
    padding: 2px;
    height: 30px;
  }

  .file-count {
    display: flex;
    margin-right: 58px;
  }

  .slick-prev {
    top: 17px !important;
    right: -105px !important;
    left: auto;
    color: red;
  }

  .slick-next {
    top: 17px !important;
    right: -170px !important;
    color: red;
  }

  button {
    width: 32px;
    height: 32px;
    flex-shrink: 0;
    border-radius: 7px;
    background: #f6f5f8;
    outline: none;
    border: none;
    cursor: pointer;
    display: flex;
    align-items: center;
    justify-content: center;
    margin-right: 65px;
  }
`;

export const TabItem = styled.div`
  height: 28px;
  flex-shrink: 0;
  padding: 2px 16px 0 16px;
  border-radius: 7px;
  transition: 0.4s ease-in-out all;
  cursor: pointer;

  ${({ active }) =>
    active &&
    `
  background: #fff;
  box-shadow: 0px 2px 4px 0px rgba(0, 0, 0, 0.1);
  `}

  color: #242424;
  text-align: center;
  leading-trim: both;
  text-edge: cap;
  font-size: 14px;
  font-weight: 500;
  line-height: 24px; /* 171.429% */

  overflow: hidden;
  display: -webkit-box;
  -webkit-line-clamp: 1;
  -webkit-box-orient: vertical;
`;

export const ModalWrapper = styled.div`
  width: 336px;
  margin-top: 16px;
  padding-top: 15px;
  border-top: 1px solid #e2e2e2;

  label {
    margin-left: 0 !important;
    width: 100%;
  }
`;

export const SearchFilesList = styled.ul`
  margin: 15px 0 0 0;
  padding: 0;
  list-style: none;
  max-height: 323px;
  overflow-y: scroll;

  li {
    width: calc(100% - 34px);
    height: 42px;
    display: flex;
    align-items: center;
    gap: 8px;
    cursor: pointer;
    color: var(--Dark-black, #242424);
    font-size: 14px;
    font-weight: 500;
    line-height: normal;
  }
`;
